// extracted by css-extract-rspack-plugin
export default {"layoutToggleFormControl":"layout-toggle-module__layoutToggleFormControl__cvw3DXz"};